import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'
import { DetailBlock, DetailFacts, DetailSkeletonRoot } from './styled'

export default function ResearchDetailSkeleton({ label }) {
    return (
        <DetailSkeletonRoot aria-label={label}>
            <BaseSkeleton height={14} width={110} />
            <BaseSkeleton height={12} width={90} />
            <BaseSkeleton height={48} width="82%" />
            <DetailFacts>{Array.from({ length: 4 }).map((_, index) => <BaseSkeleton key={index} height={62} width="100%" />)}</DetailFacts>
            {Array.from({ length: 2 }).map((_, index) => (
                <DetailBlock key={index}><BaseSkeleton height={25} width={190} /><BaseSkeleton height={16} width="64%" /><BaseSkeleton height={16} width="44%" /></DetailBlock>
            ))}
        </DetailSkeletonRoot>
    )
}
